module.exports = __webpack_public_path__ + "img/RedPillBot.b258b478.png";